import { useAppContext } from "@/context/app"

export function BoolComp({v} : {v: boolean | undefined}) {
    const { translates } = useAppContext()
    if(!translates) {
        return null
    }
    return v === undefined ? '-' : v ? translates.for('bool.true') : translates.for('bool.false')
}